"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetClientHotelBedOptions = void 0;
const resetClientHotelBedOptions = async (supabase, variant_id) => {
    const { data } = await supabase
        .from("order_variants")
        .select("*")
        .eq("id", variant_id)
        .single();
    const v = data;
    if (!v.config) {
        v.config = {
            legs: [],
            tee_times_confirmed: {},
            hotel_bed_options: {},
            airport_transfers_confirmed: {},
            transfer_address_details_confirmed: {},
        };
    }
    v.config = {
        ...v.config,
        hotel_bed_options: {},
    };
    await supabase
        .from("order_variants")
        .update({ config: v.config })
        .eq("id", v.id);
};
exports.resetClientHotelBedOptions = resetClientHotelBedOptions;
